import { render, staticRenderFns } from "./B2bproductDetails.vue?vue&type=template&id=686e36de&scoped=true&"
import script from "./B2bproductDetails.vue?vue&type=script&lang=js&"
export * from "./B2bproductDetails.vue?vue&type=script&lang=js&"
import style0 from "./B2bproductDetails.vue?vue&type=style&index=0&id=686e36de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e36de",
  null
  
)

export default component.exports